import React from 'react';
import {Link} from 'react-router-dom';
import {
    FiArrowLeft,
    FiBookOpen,
    FiBarChart2,
    FiCheckCircle,
    FiClipboard,
    FiCpu,
    FiHeadphones,
    FiHelpCircle,
    FiMail,
    FiMenu,
    FiPhone,
    FiPlayCircle,
    FiShield,
    FiUsers,
    FiX,
    FiZap,
} from 'react-icons/fi';
import {authStorage} from '../services/api';
import './HomePage.css';

const Logo = `${process.env.PUBLIC_URL}/img/SAM-logo.svg`;

const features = [
    {icon: <FiCpu/>, title: 'طراحی خودکار آزمون', text: 'متناسب با محتوای آموزشی و هدف ارزیابی، سؤال‌های پیشنهادی و ساختار اولیه آزمون را سریع‌تر آماده کنید.'},
    {icon: <FiClipboard/>, title: 'کنترل کامل پیش از انتشار', text: 'سؤال‌ها، نمره‌ها و تنظیمات آزمون را بازبینی کنید و نسخه نهایی را با اطمینان منتشر کنید.'},
    {icon: <FiPlayCircle/>, title: 'برگزاری ساده و باکیفیت', text: 'دانشجو در یک محیط روشن و منظم آزمون می‌دهد و مدرس روند برگزاری را مدیریت می‌کند.'},
    {icon: <FiBarChart2/>, title: 'تصحیح خودکار و نتیجه شفاف', text: 'پاسخ‌های قابل تصحیح به‌صورت خودکار ارزیابی می‌شوند و نتیجه و جزئیات آن قابل پیگیری است.'},
];

const steps = [
    {number: '۰۱', title: 'هدف آزمون را مشخص کنید', text: 'محتوا، موضوع و تنظیمات موردنیاز آزمون را انتخاب کنید.'},
    {number: '۰۲', title: 'آزمون را خودکار طراحی کنید', text: 'پیشنهادهای سامانه را بازبینی و آزمون را مطابق نیاز خود نهایی کنید.'},
    {number: '۰۳', title: 'برگزار کنید و نتیجه بگیرید', text: 'آزمون را ساده برگزار کنید و از تصحیح خودکار پاسخ‌های پشتیبانی‌شده بهره ببرید.'},
];

const supportEmail = process.env.REACT_APP_SUPPORT_EMAIL?.trim();
const supportPhone = process.env.REACT_APP_SUPPORT_PHONE?.trim();
const supportHours = process.env.REACT_APP_SUPPORT_HOURS?.trim();
const supportPhoneHref = supportPhone?.replace(/[^+\d]/g, '');

export default function HomePage() {
    const [menuOpen, setMenuOpen] = React.useState(false);
    const isAuthenticated = authStorage.isAuthenticated();
    const actionPath = isAuthenticated ? '/dashboard' : '/login';
    const actionLabel = isAuthenticated ? 'ورود به داشبورد' : 'شروع کار با سامانه';
    const accountLabel = isAuthenticated ? 'ورود به داشبورد' : 'ورود به سامانه';

    const closeMenu = () => setMenuOpen(false);

    return (
        <div className="landing-page">
            <header className="landing-header">
                <div className="landing-container landing-nav">
                    <Link className="landing-brand" to="/" onClick={closeMenu}>
                        <img src={Logo} alt="لوگوی سام"/>
                        <span><strong>سام</strong><small>سامانه آزمون مجازی</small></span>
                    </Link>

                    <button
                        className="landing-menu-toggle"
                        type="button"
                        onClick={() => setMenuOpen((current) => !current)}
                        aria-label={menuOpen ? 'بستن منو' : 'باز کردن منو'}
                    >
                        {menuOpen ? <FiX/> : <FiMenu/>}
                    </button>

                    <nav className={`landing-links ${menuOpen ? 'open' : ''}`} aria-label="منوی اصلی">
                        <a href="#features" onClick={closeMenu}>امکانات</a>
                        <a href="#process" onClick={closeMenu}>نحوه کار</a>
                        <a href="#support" onClick={closeMenu}>پشتیبانی</a>
                        <a href="#about" onClick={closeMenu}>درباره سامانه</a>
                        <Link className="landing-login-link" to={actionPath} onClick={closeMenu}>{accountLabel}</Link>
                    </nav>
                </div>
            </header>

            <main>
                <section className="landing-hero">
                    <div className="landing-container hero-layout">
                        <div className="landing-hero-copy">
                            <span className="landing-kicker"><FiZap/> طراحی و تصحیح هوشمند آزمون</span>
                            <h1>آزمون را خودکار طراحی کنید؛ <em>ساده و باکیفیت</em> برگزار کنید.</h1>
                            <p>سام از طراحی سؤال و آماده‌سازی آزمون تا برگزاری روان و تصحیح خودکار، مسیر ارزیابی را برای مدرس و دانشجو کوتاه‌تر و شفاف‌تر می‌کند.</p>
                            <div className="landing-hero-actions">
                                <Link className="landing-primary-btn" to={actionPath}>{actionLabel}<FiArrowLeft/></Link>
                                <a className="landing-secondary-btn" href="#features">مشاهده امکانات</a>
                            </div>
                            <div className="landing-trust">
                                <span><FiCheckCircle/> طراحی خودکار</span>
                                <span><FiCheckCircle/> برگزاری ساده</span>
                                <span><FiCheckCircle/> تصحیح خودکار</span>
                            </div>
                        </div>

                        <div className="landing-preview" aria-label="نمایش مسیر آزمون در سام">
                            <div className="preview-glow"/>
                            <div className="preview-window">
                                <div className="preview-topbar">
                                    <div><span/><span/><span/></div>
                                    <small>مسیر آزمون در سام</small>
                                </div>
                                <div className="preview-body">
                                    <aside>
                                        <div className="preview-logo"><FiClipboard/></div>
                                        <i className="active"/><i/><i/><i/>
                                    </aside>
                                    <div className="preview-content">
                                        <div className="preview-heading"><div><b>آزمون باکیفیت، بدون پیچیدگی</b><small>از ایده اولیه تا نتیجه نهایی</small></div><FiZap/></div>
                                        <div className="preview-flow">
                                            <article><span>۱</span><div className="preview-flow-icon"><FiBookOpen/></div><div><b>تعیین محتوا و هدف</b><small>انتخاب مباحث و تنظیم سطح ارزیابی</small></div></article>
                                            <article><span>۲</span><div className="preview-flow-icon"><FiCpu/></div><div><b>طراحی خودکار آزمون</b><small>ساخت و بازبینی سؤال‌های پیشنهادی</small></div></article>
                                            <article><span>۳</span><div className="preview-flow-icon"><FiPlayCircle/></div><div><b>برگزاری ساده و مطمئن</b><small>تجربه‌ای روان برای مدرس و دانشجو</small></div></article>
                                            <article><span>۴</span><div className="preview-flow-icon"><FiBarChart2/></div><div><b>تصحیح خودکار</b><small>نتیجه سریع، شفاف و قابل پیگیری</small></div></article>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="floating-card floating-card-top"><FiCpu/><span><strong>طراحی خودکار</strong><small>آزمونی متناسب با هدف شما</small></span></div>
                            <div className="floating-card floating-card-bottom"><FiCheckCircle/><span><strong>تصحیح خودکار</strong><small>نتیجه سریع و شفاف</small></span></div>
                        </div>
                    </div>
                </section>

                <section className="landing-section" id="features">
                    <div className="landing-container">
                        <div className="landing-section-heading">
                            <span>امکانات سامانه</span>
                            <h2>از طراحی تا نتیجه، هوشمند و یکپارچه</h2>
                            <p>ابزارهای لازم برای ساخت، برگزاری و تصحیح یک آزمون باکیفیت در یک فضای ساده کنار هم قرار گرفته‌اند.</p>
                        </div>
                        <div className="landing-features">
                            {features.map((feature) => (
                                <article key={feature.title}>
                                    <div className="feature-icon">{feature.icon}</div>
                                    <h3>{feature.title}</h3>
                                    <p>{feature.text}</p>
                                </article>
                            ))}
                        </div>
                    </div>
                </section>

                <section className="landing-process" id="process">
                    <div className="landing-container process-layout">
                        <div className="landing-section-heading process-heading">
                            <span>مسیر کوتاه و روشن</span>
                            <h2>سه گام تا یک آزمون باکیفیت</h2>
                            <p>بدون پیچیدگی‌های اضافه، آزمون را طراحی کنید، برگزار کنید و نتیجه را سریع‌تر تحویل بگیرید.</p>
                            <Link className="landing-text-link" to={actionPath}>شروع کار با سامانه <FiArrowLeft/></Link>
                        </div>
                        <div className="landing-steps">
                            {steps.map((step) => (
                                <article key={step.number}>
                                    <strong>{step.number}</strong>
                                    <div><h3>{step.title}</h3><p>{step.text}</p></div>
                                </article>
                            ))}
                        </div>
                    </div>
                </section>

                <section className="landing-support" id="support">
                    <div className="landing-container support-layout">
                        <div className="landing-section-heading support-heading">
                            <span>پشتیبانی سامانه</span>
                            <h2>برای استفاده از سام تنها نمی‌مانید</h2>
                            <p>برای مشکلات ورود، راهنمای استفاده و پیگیری خطاهای فنی، مسیر ارتباط مناسب را اینجا پیدا کنید.</p>
                        </div>

                        <div className="support-grid">
                            <article className="support-card">
                                <div className="support-icon"><FiUsers/></div>
                                <div>
                                    <h3>مشکل ورود و حساب کاربری</h3>
                                    <p>برای بازیابی دسترسی، تغییر اطلاعات حساب یا فعال‌سازی نقش کاربری با مدیر آموزش یا پشتیبانی سازمان خود تماس بگیرید.</p>
                                </div>
                            </article>

                            <article className="support-card support-card-primary">
                                <div className="support-icon"><FiHeadphones/></div>
                                <div>
                                    <h3>پشتیبانی فنی سامانه</h3>
                                    <p>برای بررسی سریع‌تر، نام سازمان، بخش مربوط و شرح کوتاهی از مشکل را همراه پیام خود ارسال کنید.</p>
                                    <div className="support-contact-list">
                                        {supportEmail && <a href={`mailto:${supportEmail}`}><FiMail/><span><small>پست الکترونیکی</small><b dir="ltr">{supportEmail}</b></span></a>}
                                        {supportPhone && <a href={`tel:${supportPhoneHref}`}><FiPhone/><span><small>شماره تماس</small><b dir="ltr">{supportPhone}</b></span></a>}
                                        {supportHours && <span><FiHelpCircle/><span><small>زمان پاسخ‌گویی</small><b>{supportHours}</b></span></span>}
                                        {!supportEmail && !supportPhone && !supportHours && <span><FiHelpCircle/><span><small>مسیر ارتباط</small><b>اطلاعات تماس پشتیبانی از سوی سازمان شما اعلام می‌شود.</b></span></span>}
                                    </div>
                                </div>
                            </article>

                            <article className="support-card">
                                <div className="support-icon"><FiShield/></div>
                                <div>
                                    <h3>گزارش خطای فنی</h3>
                                    <p>نام صفحه، زمان رخداد و کاری را که پیش از خطا انجام داده‌اید ذکر کنید؛ اطلاعات ورود یا رمز عبور خود را ارسال نکنید.</p>
                                </div>
                            </article>
                        </div>
                    </div>
                </section>

                <section className="landing-about" id="about">
                    <div className="landing-container about-card">
                        <div>
                            <span className="landing-kicker"><FiBookOpen/> همراه مدرس و دانشجو</span>
                            <h2>سام، دستیار آموزشی دانشگاه</h2>
                            <p>برای طراحی خودکار، برگزاری ساده و تصحیح سریع‌تر آزمون؛ با تجربه‌ای روان، یکپارچه و فارسی.</p>
                        </div>
                        <Link className="landing-light-btn" to={actionPath}>{actionLabel}<FiArrowLeft/></Link>
                    </div>
                </section>
            </main>

            <footer className="landing-footer">
                <div className="landing-container">
                    <div className="landing-brand">
                        <img src={Logo} alt="لوگوی سام"/>
                        <span><strong>سام</strong><small>سامانه آزمون مجازی</small></span>
                    </div>
                    <div className="landing-footer-links">
                        <a href="#features">امکانات</a>
                        <a href="#process">نحوه کار</a>
                        <a href="#support">پشتیبانی</a>
                    </div>
                    <p>سامانه هوشمند مدیریت و طراحی آزمون</p>
                </div>
            </footer>
        </div>
    );
}
